module.exports = __webpack_public_path__ + "static/media/recent-big-win.fc48b25c.jpg";